module.exports = __webpack_public_path__ + "static/blackhearts-sparrows-832a7e6bd95229b31fd359c17b78e806.jpg";